import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export const inboxRoutes = [
  {
    path: "/inbox",
    redirect: "/app/inbox",
  },
  {
    path: "/app/inbox",
    component: () => import("vue-app/pages/PageInbox.vue"),
    meta: {
      routeName: "Inbox",
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_INBOX],
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
  {
    path: "/app/inbox/reports",
    component: () => import("../pages/PageDashboardInbox.vue"),
    meta: {
      routeName: window.$_t("Inbox Reports"),
      requiredRoles: [AGENT_TRACKER_ROLE.ROLE_REPORTS],
      skipGlobalLoader: true,
    },
  },
];
